import { createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme) =>
  createStyles({
    inputWrapper: {
      width: '100%',
      display: 'flex',
      justifyContent: 'flex-start',
      flexShrink: 0,
      flexWrap: 'wrap',
      gap: theme.spacing(3),
    },
    input: {
      width: '100%',
      maxWidth: 400,
    },
  })
);
